// vars declaration

var body = document.querySelector('body');
var siteHeader = document.querySelector('.site-header');

// minimum Window's width for showing responsive menu and freezing header
var minimumWidth = 1279;

var dropdownTrigger = $(".dropdownTrigger");
var dropdownContent = $(".dropdownContent");
var dropdown = $(".dropdownTrigger, .dropdownContent");

var extraTrigger = $('.extraTrigger');
var extraContent = $('.extraContent');
var extraClass = "hidingExtra";